import { ConfirmModal } from '../../commons/components/ConfirmModal';
import React from 'react';
import { ReleasePromptData } from '../types';
import useAnalyticsPage from '../../web-analytics/hooks/useAnalyticsPage';
import { Page } from '../../web-analytics/Page';

export const ReleasePromptDialog = (props: {
  prompt: ReleasePromptData;
  onNavigate: () => void;
  onCancel: () => void;
  onCheckLater: () => void;
}) => {
  const { prompt, onNavigate, onCancel, onCheckLater } = props;
  useAnalyticsPage(Page.RELEASE_PROMPT, { promptCode: prompt.code });
  return (
    <ConfirmModal
      title={prompt.title}
      message={typeof prompt.content === 'string' ? prompt.content : undefined}
      ariaHideApp={false}
      footer={{
        type: 'show',
        applyButton: prompt.route
          ? {
              label: prompt.route ? 'Explore' : 'Close',
              onClick: onNavigate,
            }
          : undefined,
        cancelButton: {
          label: 'Skip',
          onClick: onCancel,
        },
        extraButtons: [
          {
            label: 'Check later',
            onClick: onCheckLater,
          },
        ],
      }}
    >
      {typeof prompt.content !== 'string' ? prompt.content : null}
    </ConfirmModal>
  );
};
